// src/app/styles.js
//
// Shared inline-style objects extracted from the legacy monolith's `S`
// constant. Same scoping rule as tokens.js: partial extraction, just the
// keys needed by the Locations slice. Other slices will add to this file
// as they land.

import { T } from "./tokens.js";

export const PAGE_ZONE = {
  maxWidth: 1200,
  margin: "0 auto",
};

export const S = {
  // DEPRECATED (INC-05 — LSE-STYLE-NORMALIZE-1): Use the Card component or
  // CARD_STYLE from src/components/Card.jsx for new surfaces.
  // S.card has borderBottom-only and no shadow — the canonical pattern has a
  // full perimeter border (1px solid T.border), radius 8, and T.cardShadow.
  // Remaining callers were migrated in LSE-STYLE-NORMALIZE-1; this definition
  // is retained only to avoid a sudden removal breaking any caller that was
  // missed. Remove when zero grep hits remain.
  card: {
    background:   T.card,
    border:       `1px solid ${T.border}`,
    borderRadius: 8,
    boxShadow:    T.cardShadow,
  },
  // DEPRECATED (GLOBAL-PILL-STANDARDIZE): S.badge must no longer be used as a
  // pill shape primitive. The canonical pill spec is: borderRadius 6, no border,
  // padding "2px 10px", T.fsXs, T.fwSemibold, tinted fill — use inline styles
  // matching that spec, or import StatusPill from src/v2/components/StatusPill.jsx.
  // S.badge is retained here only to avoid crashing the few layout callers that
  // still spread it; its borderRadius / border fields are intentionally retired.
  // Remove when grep shows zero remaining pill consumers.
  badge: {
    fontSize:    T.fsXs,
    fontWeight:  T.fwSemibold,
    display:     "inline-flex",
    alignItems:  "center",
    lineHeight:  1,
    whiteSpace:  "nowrap",
    letterSpacing: 0.3,
  },
  label: {
    fontSize: T.fsSm,
    fontWeight: T.fwSemibold,
    color: T.dark,
    marginBottom: 4,
    display: "block",
  },
  emptyState: {
    padding: 16,
    textAlign: "center",
    color: T.light,
  },
  panelPad: {
    padding: 16,
  },
  sectionTitle: {
    fontSize: T.fsLg,
    fontWeight: T.fwBold,
    color: T.dark,
    marginBottom: 12,
  },
  statValue: {
    fontSize: T.fsLgX5,
    fontWeight: T.fwDisplay,
    letterSpacing: -0.5,
  },
  statLabel: {
    fontSize: T.fsXxs,
    fontWeight: T.fwSemibold,
    textTransform: "uppercase",
    letterSpacing: 0.8,
  },
  paneGap: 12,
};
